import { assign, pickBy } from 'lodash'

import { createActionTypes } from '.'

export const LOAD_KEYWORDS_FROM_CACHE = createActionTypes(
  'LOAD_KEYWORDS_FROM_CACHE',
)

export const ADD_REPORT_ID_TO_POLLING = createActionTypes(
  'ADD_REPORT_ID_TO_POLLING',
)

export const REMOVE_REPORT_IDS_FROM_POLLING = createActionTypes(
  'REMOVE_REPORT_IDS_FROM_POLLING',
)

export const UPDATE_METRICS_LIMITS = createActionTypes('UPDATE_METRICS_LIMITS')

export const SET_POLLING = createActionTypes('SET_POLLING')

export const UPDATE_KEYWORDS_METRICS = createActionTypes(
  'UPDATE_KEYWORDS_METRICS',
)

export const loadKeywordsFromCacheSuccess = (keywords) => ({
  type: LOAD_KEYWORDS_FROM_CACHE.success,
  keywords,
})

export const updateKeywordsMetrics = (keywords, isSD = true) => ({
  type: UPDATE_KEYWORDS_METRICS.action,
  payload: { keywords, isSD },
})

export const updateMetricsLimits = (payload) => ({
  type: UPDATE_METRICS_LIMITS.action,
  payload,
})

export const KeywordsSDBank = sessionStorage
export const KEY_KEYWORDS_SD_VALUE = 'ub_keywords_sb'
export const SD_VALUE_TTL = 2 * 60 * 60 * 1000
export const SD_VALUE_PENDING_TTL = 10 * 1000
export const KEYWORDS_SD_POLL_INTERVAL = 5000
export const isValidSD = (sdInfo) =>
  sdInfo &&
  sdInfo.updated_at &&
  sdInfo.updated_at + SD_VALUE_TTL / 1000 > Date.now() / 1000
export const getPendingUpdatedAt = () =>
  (Date.now() - SD_VALUE_TTL + SD_VALUE_PENDING_TTL) / 1000
export const mergeKeywordsSd = (origin, newSds) => {
  return assign(
    pickBy(origin, (value) => isValidSD(value)), // only pick and save keywords that are updated within 2 hours
    newSds,
  )
}
